<div class="header" fxLayout="row" class="header" data-test-id="hdContainer">
  <div class="hdLogoContainer">
    <img
      [src]="
        'spa/cigna-for-brokers/assets/images/cignahlthcr_logo_color.svg'
          | cdnPrefix
      "
    />
    <span class="brLogoSep">{{ 'home.borkers' | translate }}</span>
  </div>
</div>
<div class="error-container">
  <div class="back-button">
    <a (click)="naviagateToLogin()"
      ><cigna-icon type="chevron-left" class="left-chevron"></cigna-icon>
      {{ 'home.back' | translate }}</a
    >
  </div>
  <div class="img-banner">
    <img
      [src]="'spa/cigna-for-brokers/assets/images/group_auto.png' | cdnPrefix"
    />
  </div>
  <div class="error-display-section">
    <h3>{{ 'home.unAvailable' | translate }}</h3>
    <h4>{{ 'home.tryAgain' | translate }}</h4>
  </div>
</div>
<footer>
  <div class="cfb">
    <div
      fxLayout="row"
      fxLayout.xs="column"
      fxLayoutAlign="center center"
      fxLayoutAlign.xs="left top"
      fxLayoutGap="2rem"
      fxLayoutGap.xs="0rem"
    >
      <div class="login__footerLinks">
        <small>
          &copy; {{ currentYear }} {{ 'footer.copyRight' | translate }}</small
        >
        <a
          target="_blank"
          href="https://www.cigna.com/legal/compliance/privacy-notices"
          rel="noopener noreferrer"
          >{{ 'footer.privacy' | translate }}</a
        >
        <a
          target="_blank"
          [href]="'https://www.cigna.com/legal/compliance/disclaimers'"
          >{{ 'footer.legalDisclaimer' | translate }}
        </a>
      </div>
    </div>

    <div fxLayout="column" class="footer-text">
      <p>
        {{ 'footer.broker.term6' | translate }}
      </p>
      <p>
        {{ 'footer.broker.term7' | translate }}
        <a (click)="showContactModal()">Contact Us.</a>
        <br />

        <span class="extranl-link-icon"
          ><cigna-icon type="external-link" class="download-link"></cigna-icon
        ></span>
        {{ 'footer.broker.term8' | translate }}
      </p>
    </div>
  </div>
</footer>
